import React, { useContext, useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { GetUserContext } from '../Context/GetUserContext';
import BannerHome from '../Components/BannerHome'
import CarMarket from '../Components/CarMarket';
import Container from 'react-bootstrap/Container';
import SearchParts from '../Components/PageHome/SearchParts';
import Navbar from 'react-bootstrap/Navbar';
import Replacements from '../Components/PageHome/Replacements';
import "./PageHome.css";
import Fraga from '../controller/api/Fraga';
import Load from '../Components/Load';
import Product_Fraga from '../Components/Product_Fraga';
import PaginationProducts from '../Components/PaginationProducts';
import aplications from '../controller/api/Aplications';

const PageHome = () => {
    const { setFabricanteArray, ordenarPreco, load, conjIdHome,
        pageIsLogin, setPageIsLogin, products, size,
        activedPagination, setActivedPagination
    } = useContext(GetUserContext);
    const [prod, setprod] = useState([]);
    const Aplications = new aplications();

    useEffect(() => {
        Aplications.getAllFabricantes()
            .then(fabricante => {
                setFabricanteArray(fabricante?.data)
            })
            .catch(err => {
                return console.log(err)
            })
    }, [])
    useEffect(() => {
        setPageIsLogin(false)
    }, [pageIsLogin, setPageIsLogin]);
    useEffect(() => {
        if (products?.length) {
            const sortedProducts = [...products].sort((a, b) => {
                if (ordenarPreco == 1) {
                    return b?.produtoAuri?.Preco_4 - a?.produtoAuri?.Preco_4;
                } else if (ordenarPreco == 2) {
                    return a?.produtoAuri?.Preco_4 - b?.produtoAuri?.Preco_4;
                }
                return 0;
            });
            setprod(sortedProducts);
        }
    }, [ordenarPreco, products]);

    return (
        <>
            {load ? (<Load />) : (<></>)}
            <Card className='card-container'>
                {
                    size?.categoria !== 'xlarge' && size?.categoria !== 'large' ?
                        (<Navbar className="bg-body-tertiary" style={{ position: 'sticky', top: 0, zIndex: 1020 }}>
                            <Container>
                                <CarMarket />
                            </Container>
                            <br></br>
                        </Navbar>)
                        :
                        (<></>)
                }
                <Card.Body>
                    <div className='area-banner-home'> <BannerHome /> </div>
                    {conjIdHome == 1 && (<SearchParts />)}
                </Card.Body>

                {conjIdHome == 1 &&
                    (<><div id="btnSearch" className='area-result-products'>
                        {prod.map((product, index) => (
                            <React.Fragment key={index}>
                                <Product_Fraga product={product} />
                            </React.Fragment>
                        ))}
                    </div> {!activedPagination ? (<></>) : (<>
                        {products?.length === 50 && <PaginationProducts />}

                    </>)}
                    </>)}
            </Card>
            {
                size?.categoria !== 'xlarge' && size?.categoria !== 'large' ?
                    (<></>)
                    :
                    (<CarMarket />)
            }
        </>
    )
}

export default PageHome